var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('md-button',{staticClass:"md-primary md-sm",nativeOn:{"click":function($event){return _vm.logout($event)}}},[_vm._v("Logout")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }